import { Injectable } from '@angular/core';
import { crmFormRequiredValidator } from 'common-module/form';
import { Observable, of } from 'rxjs';
import { CrmFormFragment } from 'common-module/form/fragments';
import {
  CrmFormInputComponent,
  CrmFormPasswordComponent,
} from 'common-module/form/inputs';
import { CrmLoginFormProvider } from 'common-module/auth';

@Injectable()
export class LoginFormProvider extends CrmLoginFormProvider {
  protected override getFormFragments(): Observable<CrmFormFragment[]> {
    return of([
      {
        type: 'data-input',
        name: 'username',
        content: CrmFormInputComponent,
        contentContext: {
          config: {
            label: 'auth.login.username.label',
            validators: [crmFormRequiredValidator()],
          },
          options: {
            placeholder: 'auth.login.username.placeholder',
          },
        } as Partial<CrmFormInputComponent>,
      },
      {
        type: 'data-input',
        name: 'password',
        content: CrmFormPasswordComponent,
        contentContext: {
          config: {
            label: 'auth.login.password.label',
            validators: [crmFormRequiredValidator()],
          },
          options: {
            placeholder: 'auth.login.password.placeholder',
          },
        } as Partial<CrmFormPasswordComponent>,
      },
    ]);
  }
}
